import React from 'react';
import { Flex, Row, Card, Statistic, Alert } from 'antd';
import { HomeOutlined, ShoppingOutlined, DollarOutlined, EuroOutlined, QuestionCircleOutlined  } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import NavItem from '../../components/nav-item';
import Withdraw from '../../components/withdraw';
import { safeCall } from "../../utils/jsbridge"; // 添加这一行
import { getCurrentShopId } from '../shop/get-current-shop';

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版'
}

const iconStyle = {
  fontSize: 28,
}
const cardStyle = {
    flex: 1
}
const Index = () => {
    const [shopId, setShopId] = React.useState(null);
    const [summary, setSummary] = React.useState({});
    const {versionId, wdRate, cwdRate } = window.__baseInfo;
    // 获取店铺信息
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            loadShopSummary();
        }
    }, [shopId]);

    const loadShopSummary = async () => {
        getShopSummary(shopId).then(res => {
            setSummary(res.data);
        });
    }

    const getShopSummary = async (shopId) => {
        const res = await fetch(`/api/finance/fund-summary?shopId=${shopId}`);
        const result = await res.json();
        return result;
    }

    return (
        <div>
            <SwitchShop />
            
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/finance/order-flow" text="支付流水">
                    <ShoppingOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/finance/funding-flow" text="资金流水">
                    <DollarOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/finance/funding-flow-invite" text="邀请资金流水">
                    <EuroOutlined style={iconStyle} />
                </NavItem>

                <NavItem href={`/shop/create?shopId=${shopId}`} text="银行卡管理">
                    <HomeOutlined style={iconStyle} />
                </NavItem>

                {/* <NavItem href="/" text="提现">
                    <HomeOutlined style={iconStyle} />
                </NavItem> */}
            </Row>

            <Flex gap={10} wrap>
                <Card style={cardStyle}>
                    <Statistic
                        title="余额"
                        value={summary.totalAmount/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="可提现"
                        value={(summary.withdrawAmount + summary.pendingAmount)/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix={txBtn}
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="待入账"
                        value={summary.frozenAmount/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="本月营收"
                        value={summary.monthIncome/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>
            </Flex>
            
            {/* 使用新的Withdraw组件，包含了按钮和弹窗 */}
            <Withdraw 
                style={{margin: '10px 0 0 0'}}
                maxAmount={summary.withdrawAmount/100}
                disabled={summary.withdrawAmount <= 0}
                type="order"
            />

            <span style={{marginLeft: '10px'}}><QuestionCircleOutlined /> 遇到问题请<a onClick={() => safeCall('16657132266')}>联系客服</a></span>
            
            <Alert
                style={{margin: '10px 0 0 0'}}
                message="账户信息"
                description={
                    <div>
                        <div>版本：{versionMap[versionId]}</div>
                        <div>提现费率：{cwdRate * 100}%(<span style={{textDecoration: 'line-through'}}>{wdRate * 100}%</span>)</div>
                        <div>提现方式：{versionId === 1 ? '手动提现': '自动提现'}</div>
                    </div>
                }
                type="info"
            />
        </div>
    )
}

export default Index;